import pageActions from 'core/page/actions';
import dialogActions from 'core/dialogs/actions';
import homeActions from './actions';

export default (state = {}, action) => {
  switch (action.type) {
    case homeActions.FETCH: {
      const { endpoint, id } = action.payload;
      const { data, isOpen, meta } =
        (state[id] && state[id][endpoint] && state[id][endpoint]) || {};
      return {
        ...state,
        [id]: {
          ...state[id],
          [endpoint]: {
            data: data || null,
            isOpen: data ? !isOpen : true,
            meta: meta || null,
          },
        },
      };
    }
    case homeActions.FETCH_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          [action.payload.endpoint]: {
            data: action.payload.data,
            isOpen: true,
            meta: action.payload.meta,
          },
        },
      };

    case dialogActions.AGREE_SUCCESS:
    case dialogActions.SIGN_SUCCESS:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          [action.payload.endpoint]: {
            data: action.payload.data.data,
            isOpen: true,
          },
        },
      };
    case pageActions.GO_SUCCESS:
      return {};
    default:
      return state;
  }
};
